export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Animated_Gifs_es.bf234fe.vtt";